import React         from 'react';
import { createRoot }      from 'react-dom/client';
import AudioRecorder from 'audio-recorder-polyfill';
import CssBaseline   from '@mui/material/CssBaseline';

import LandingPageIndex from 'pages/LandingPage';

import AppTheme from 'components/App/Theme';

window.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('landing-page-wrapper');
  if (!container) return false;

  const root = createRoot(container);

  root.render(
    <AppTheme>
      <CssBaseline />
      <LandingPageIndex />
    </AppTheme>,
  );

  return true;
});

if (typeof MediaRecorder === 'undefined') {
  window.MediaRecorder = AudioRecorder;
}
